const state = {
  swipeMenu: true, // состояние боковой кнопки-переключателя при просмотре на мобильных устройствах
  navMenu: false, // показывает/скрывает меню при просмотре на мобильных устройствах (burger-icon)
  postModal: false,
  activeModal: {
    type: false,
    param: false,
    text: false,
    title: false,
    action: false,
    call: false, // применяет callback в компонентах с использованием $watch(action)
  },
  callPrint: false,
};

const getters = {
  getNavMenuState: (state) => {
    return state.navMenu;
  },
  printArticle: (state) => {
    return state.callPrint;
  },
  getSwipeMenuState: (state) => {
    return state.swipeMenu;
  },
  getPostModal: (state) => {
    return state.postModal;
  },
  getActiveModal: (state) => {
    return state.activeModal.type;
  },
  getModalParam: (state) => {
    return state.activeModal.param;
  },
  getModalAction: (state) => {
    return state.activeModal.call;
  },
  getActiveModalData: (state) => {
    return state.activeModal;
  },
};

const mutations = {
  resetModal(state) {
    state.activeModal = {
      type: false,
      param: false,
      text: false,
      title: false,
      action: false,
      call: false, // применяет callback в компонентах с использованием $watch(action)
    };
  },
  setNavMenuState: (state, newState) => {
    state.navMenu = newState;
  },
  setSwipeMenuState: (state, newState) => {
    state.swipeMenu = newState;
  },
  setPostModal: (state, baseId) => {
    state.postModal = baseId;
  },
  togglePrint: (state) => {
    state.callPrint = !state.callPrint;
  },
  setActiveModal: (state, modalData) => {
    const modalParams = Object.keys(modalData);
    modalParams.forEach((key) => (state.activeModal[key] = modalData[key]));
  },
  disableModal: (state) => {
    state.activeModal.type = false;
  },
  setModalCall: (state) => {
    state.activeModal.call = state.activeModal.action;
    state.activeModal.type = false;
    state.activeModal.action = false;
  },
};

const actions = {
  navMenuToggle({ commit }) {
    commit("setNavMenuState", !state.navMenu);
  },
  navMenuHide({ commit }) {
    commit("setNavMenuState", false);
  },
  swipeMenuToggle({ commit }) {
    commit("setSwipeMenuState", !state.swipeMenu);
  },
  swipeMenuShow({ commit }) {
    commit("setSwipeMenuState", true);
  },
  swipeMenuHide({ commit }) {
    commit("setSwipeMenuState", false);
  },
  callPrint({ commit }) {
    commit("togglePrint");
  },
  showModal({ commit }, modalData) {
    commit("resetModal");
    commit("setActiveModal", modalData);
  },
  showPostModal({ commit }, baseId) {
    commit("setPostModal", baseId);
  },
  updateModal({ commit }, modalData) {
    commit("setActiveModal", modalData);
  },
  callModalAction({ commit }) {
    commit("setModalCall");
  },
  dismissModal({ commit }) {
    commit("disableModal");
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
